import { extendTheme, type ThemeConfig } from '@chakra-ui/react'

const config: ThemeConfig = {
  initialColorMode: 'dark',
  useSystemColorMode: true,
}

const theme = extendTheme({
  config,
  fonts: {
    heading: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif",
    body: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif",
  },
  colors: {
    brand: {
      50: '#fff7e5',
      100: '#ffe8bf',
      200: '#ffda99',
      300: '#ffcc73',
      400: '#ffbd4d',
      500: '#ffb711',
      600: '#cc920e',
      700: '#996e0a',
      800: '#664906',
      900: '#332503',
    },
    gray: {
      50: '#F7FAFC',
      100: '#EDF2F7',
      200: '#E2E8F0',
      300: '#CBD5E0',
      400: '#A0AEC0',
      500: '#718096',
      600: '#4A5568',
      700: '#2D3748',
      800: '#1A202C',
      900: '#171923',
    },
  },
  shadows: {
    outline: '0 0 0 3px rgba(255, 183, 17, 0.3)',
  },
  components: {
    Button: {
      defaultProps: {
        colorScheme: 'brand',
        size: 'md',
      },
      variants: {
        solid: {
          fontWeight: 600,
          boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)',
          _hover: {
            transform: 'translateY(-1px)',
            boxShadow: '0 4px 6px rgba(0,0,0,0.12), 0 2px 4px rgba(0,0,0,0.24)',
          },
        },
      },
    },
    Card: {
      baseStyle: {
        container: {
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          borderRadius: 'lg',
          overflow: 'hidden',
          transition: 'all 0.3s ease',
          _hover: {
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          },
        },
        header: {
          paddingBottom: '2',
        },
        body: {
          paddingTop: '2',
        },
      },
    },
    Heading: {
      baseStyle: {
        fontWeight: '700',
        lineHeight: '1.2',
      },
    },
    Link: {
      baseStyle: {
        fontWeight: '500',
        _hover: {
          textDecoration: 'none',
        },
      },
    },
    Badge: {
      baseStyle: {
        borderRadius: 'full',
        textTransform: 'capitalize',
        fontWeight: '600',
      },
    },
  },
  styles: {
    global: (props: any) => ({
      body: {
        bg: props.colorMode === 'dark' ? 'gray.800' : 'gray.50',
      },
    }),
  },
})

export default theme 